import React, { useState } from "react";
import { ITenant } from "components/tenants/types";
import { getValidationError } from "utils/validation";

interface ContactPersonFormProps {
  formData: Partial<ITenant>;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const ContactPersonForm: React.FC<ContactPersonFormProps> = ({ formData, onChange }) => {
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const error = getValidationError(name, value);
    setErrors((prev) => ({ ...prev, [name]: error }));
    onChange(e);
  };

  return (
    <form>
      <div className="row">
        <div className="col-12 col-lg-6 mb-3">
          <label htmlFor="firstName" className="form-label">
            First Name
          </label>
          <input
            type="text"
            className={`form-control ${errors.firstName ? "is-invalid" : ""}`}
            id="firstName"
            name="firstName"
            placeholder="Enter First Name..."
            value={formData.contactPerson?.firstName || ""}
            onChange={handleChange}
          />
          {errors.firstName && <div className="invalid-feedback">{errors.firstName}</div>}
        </div>
        <div className="col-12 col-lg-6 mb-3">
          <label htmlFor="lastName" className="form-label">
            Last Name
          </label>
          <input
            type="text"
            className={`form-control ${errors.lastName ? "is-invalid" : ""}`}
            id="lastName"
            name="lastName"
            placeholder="Enter Last Name..."
            value={formData.contactPerson?.lastName || ""}
            onChange={handleChange}
          />
          {errors.lastName && <div className="invalid-feedback">{errors.lastName}</div>}
        </div>
        <div className="col-12 col-lg-6 mb-3">
          <label htmlFor="jobTitle" className="form-label">
            Job Title
          </label>
          <input
            type="text"
            className="form-control"
            id="jobTitle"
            name="jobTitle"
            placeholder="Enter Job Title..."
            value={formData.contactPerson?.jobTitle || ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-12 col-lg-6 mb-3">
          <label htmlFor="email" className="form-label">
            Email
          </label>
          <input
            type="email"
            className={`form-control ${errors.email ? "is-invalid" : ""}`}
            id="email"
            name="email"
            placeholder="Enter Email..."
            value={formData.contactPerson?.email || ""}
            onChange={handleChange}
          />
          {errors.email && <div className="invalid-feedback">{errors.email}</div>}
        </div>
        <div className="col-12 col-lg-6 mb-3">
          <label htmlFor="phone" className="form-label">
            Office Number
          </label>
          <input
            type="tel"
            className={`form-control ${errors.phone ? "is-invalid" : ""}`}
            id="phone"
            name="phone"
            placeholder="+x (xxx)-xxx-xxxx"
            value={formData.contactPerson?.phone || ""}
            onChange={handleChange}
          />
          {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
          <p className="opacity-50 mt-1 fs-6 mb-0 phone-hint">
            Phone numbers should be formatted with a + and country code.
          </p>
        </div>
        <div className="col-12 col-lg-6 mb-3">
          <label htmlFor="phoneExtension" className="form-label">
            Extension Number
          </label>
          <input
            type="text"
            className="form-control"
            id="phoneExtension"
            name="phoneExtension"
            placeholder="Enter Extension Number"
            value={formData.contactPerson?.phoneExtension || ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-12 col-lg-6 mb-3">
          <label htmlFor="mobilePhone" className="form-label">
            Mobile Number
          </label>
          <input
            type="tel"
            className={`form-control ${errors.mobilePhone ? "is-invalid" : ""}`}
            id="mobilePhone"
            name="mobilePhone"
            placeholder="+x (xxx)-xxx-xxxx"
            value={formData.contactPerson?.mobilePhone || ""}
            onChange={handleChange}
          />
          {errors.mobilePhone && <div className="invalid-feedback">{errors.mobilePhone}</div>}
        </div>
      </div>
    </form>
  );
};

export default ContactPersonForm;
